import { WORKSUITE_IDENTITY_CLIENT } from "./authConstants";
import { clearIdentitySession } from "./authStorage";
import { broadcastCampaignsAuth } from "./identityLifecycle";

function getCampaignsLoginUrl() {
  if (typeof window === "undefined") return "https://campaigns.clikkle.com/login";
  return new URL("/login", window.location.origin).toString();
}

export function clearCampaignsIdentity({ preserveOrganization = false } = {}) {
  clearIdentitySession({
    preserve: preserveOrganization
      ? ["pendingInvitationToken", "selectedOrganization"]
      : ["pendingInvitationToken"],
  });
}

export function logoutFromCampaigns({ useHostedLogout = true, switchAccount = false } = {}) {
  clearCampaignsIdentity({ preserveOrganization: false });
  broadcastCampaignsAuth("signed-out", { reason: switchAccount ? "switch_account" : "user_logout" });
  if (typeof window === "undefined") return;

  const returnUrl = switchAccount
    ? getCampaignsLoginUrl()
    : "https://worksuite.clikkle.com/campaigns";
  if (!useHostedLogout || switchAccount) {
    window.location.assign(returnUrl);
    return;
  }

  const logoutUrl = new URL("/logout", WORKSUITE_IDENTITY_CLIENT.accountsUrl);
  logoutUrl.searchParams.set("redirectto", returnUrl);
  logoutUrl.searchParams.set("referrer", window.location.origin);
  window.location.assign(logoutUrl.toString());
}
